<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="toc" role="doc-toc">
<h1 class="h1c"><span aria-label="vii" epub:type="pagebreak" id="page_vii" role="doc-pagebreak"><strong>Contents</strong></span></h1>
<p class="toc1"><a href="#/xhtml/preface"><strong>Preface</strong></a></p>
<p class="toc1"><a href="#/xhtml/introduction"><strong>Introduction: Conflict Is Not the Problem</strong></a></p>
<p class="tocs"><em>Leaders have an opportunity to be a channel for chaos or a catalyst for clarity</em>.</p>
<p class="toc-chap"><a href="#/xhtml/ch01"><strong><span class="toc-chap_float">1</span> Conflict Capacity: Comfort Is Not a Requirement</strong></a></p>
<p class="tocs"><em>Skills development that doesn’t lead to embodiment is just a notch above entertainment</em>.</p>
<p class="toc-chap"><span href="#/xhtml/ch02" title="Link target outside of Sample"><strong><span class="toc-chap_float">2</span> Identity: The Price of Being Too Nice</strong></span></p>
<p class="tocs"><em>The story that’s been resolved no longer needs to be told</em>.</p>
<p class="toc-chap"><span href="#/xhtml/ch03" title="Link target outside of Sample"><strong><span class="toc-chap_float">3</span> Leadership Clarity: Staying the Course</strong></span></p>
<p class="tocs"><em>Leadership identity is about how you see yourself, and leadership clarity is about how you see the situation</em>.</p>
<p class="toc-chap"><span href="#/xhtml/ch04" title="Link target outside of Sample"><strong><span class="toc-chap_float">4</span> Emotional Integrity: Anger Is Not the Truth</strong></span></p>
<p class="tocs"><em>Think of blame as a shortcut for avoiding responsibility</em>.</p>
<p class="toc-chap"><span href="#/xhtml/ch05" title="Link target outside of Sample"><strong><span class="toc-chap_float">5</span> Environmental Impact: Structure Determines Behavior</strong></span></p>
<p class="tocs"><em>Our perceptions and interpretations create structures of knowing</em>.</p>
<p class="toc-chap"><span href="#/xhtml/ch06" title="Link target outside of Sample"><strong><span class="toc-chap_float">6</span> Resistance Training: Working with High-Conflict People</strong></span></p>
<p class="tocs"><em>Disruptive people will continue to be disruptive as long as no one has the courage to confront them</em>.</p>
<p class="toc-chap"><span href="#/xhtml/ch07" title="Link target outside of Sample"><span aria-label="viii" epub:type="pagebreak" id="page_viii" role="doc-pagebreak"><strong><span class="toc-chap_float">7</span> Skills: A Blueprint for Difficult Conversations</strong></span></span></p>
<p class="tocs"><em>The answers will come through the conversation, not before the conversation</em>.</p>
<p class="toc-chap"><span href="#/xhtml/ch08" title="Link target outside of Sample"><strong><span class="toc-chap_float">8</span> Responsibility: The Recognition of Choice</strong></span></p>
<p class="tocs"><em>When you find your choice, you find your power</em>.</p>
<p class="toc1"><span href="#/xhtml/conclusion" title="Link target outside of Sample"><strong>Conclusion: It’s Worth It</strong></span></p>
<p class="toc1"><span href="#/xhtml/from" title="Link target outside of Sample"><strong>Study Guide and Book Club Facilitation</strong></span></p>
<p class="tocb"><span href="#/xhtml/notes" title="Link target outside of Sample"><strong>Notes</strong></span></p>
<p class="tocb"><span href="#/xhtml/bibliography" title="Link target outside of Sample"><strong>Bibliography</strong></span></p>
<p class="tocb"><span href="#/xhtml/acknowledgments" title="Link target outside of Sample"><strong>Acknowledgments</strong></span></p>
<p class="tocb"><span href="#/xhtml/index" title="Link target outside of Sample"><strong>Index</strong></span></p>
<p class="tocb"><span href="#/xhtml/author" title="Link target outside of Sample"><strong>About the Author</strong></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?743ed856